
import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { PostData } from '../Functions/SendingData';
import { Loading } from '../Loading';

const Styles = styled.div`
    margin: 16px 0 32px;
    font-size: 1rem;
    --color-imp: #0382A0;
    .loading-container {
        display: flex;
        justify-content: center;
    }
   
    .good-grid {
        width: 100%;
        overflow: auto;
        position: relative;
        ::-webkit-scrollbar-track {
            box-shadow: inset 0 0 2px rgba(0,0,0,0.3);
            background-color: var(--body-4);
            border-radius: 0;
        }
        ::-webkit-scrollbar {
            width: 2px;
            height: 2px;
        }
        ::-webkit-scrollbar-thumb {
            border-radius: 5px;
            background-color: var(--primary-2);
        }
        
        .scrollable {
            flex-grow: 1;
            width: 100%;
            display: flex;
            gap: 8px;
            padding-bottom: 4px;
            :first-child{
                margin-right: 16px;
            }
        }
        .good {
            text-decoration: none;
            color: inherit;
            font-size: 0.75rem;
            font-weight: 600;
            border-radius: 4px;
            border: 1px solid var(--gray-3);
            padding: 0.2rem 0.5rem;
            .image {
                img {
                    width: 100%;
                }
            }
            .detail {
                padding: 0 8px 4px 0;
                .nameG {
                    width: 100%;
                    overflow: hidden;
                    .name {
                        width: 100%;
                        overflow: hidden;
                    }
                    
                }
            }
        }
    }
    .sub-grid {
        width: calc(100% - 16px);
        display: flex;
        flex-direction: column;
        padding: 0 0 10px;
        margin: 0 8px;
        .top-find{
            padding: 1rem  0;
            display: flex;
            flex-direction: row;
            justify-content:space-between ;
            width: 100% ;
            .good-list-tit{
                font-weight: 500;
                font-size: 1rem;
                color: var(--gray-6);
            }
            .more-good{
                font-weight: 500;
                font-size: 0.75rem;
                color:var(--color-imp);
                text-decoration: none;
            }
        }
        .line{
            border-bottom: 1px solid var(--gray-3);
            width: 100%;
            display: block;
            margin-top: 0.8rem ;
        }
        .search-link {
            text-decoration: none;
            color: inherit;
            flex-grow: 1;
            display: flex;
            gap: 8px;
            margin-bottom: 1rem;
            color: var(--gray-6);
            .image {
                svg{
                    width: 27px;
                    height: 27px;
                }
                
            }            
            .detail {
                .nameG{
                    display: flex;
                    flex-direction: column;
                    font-size: 1rem;
                    font-weight: 700;
                    .subtitle {
                        font-size: 0.87rem;
                        font-weight: 600;
                        .imp {
                            color: var(--color-imp);
                        }
                    }
                }
            }
            
        }
    }
`

class SearchDrawerRes extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            response: 'pending',
            sending: false,
            objectData: false,
            subdata: false,
            srch:'G_NAME'
        };
    }

    // initial data for search drawer
    componentDidMount () {
        this.getSearch(this.props.keyword);
    }

    // get if saerch keyword data has updated or nor
    getSnapshotBeforeUpdate(prevProps, prevState){
        if (prevProps.keyword !== this.props.keyword){
            return true;
        } else {
            return false;
        }
    }

    // if updated get data from server
    componentDidUpdate(prevProps, prevState, snapshot){
        if (snapshot){
            this.getSearch(this.props.keyword)
        }
    }

    // get server data for serched key word
    getSearch = (keyword) => {
        if(keyword.length > 1){
            let formData = new FormData();
            formData.append('G_NAME', keyword);
            this.setState({
                response: 'pending',
                sending: true,
                objectData: false,
                subdata: false,
            });
            PostData(process.env.REACT_APP_API + '/api/v1/exb/search',formData, this, this.SearchProccess);
        }
    }

    // proccess serch response data
    SearchProccess(obj, data){
        let response = JSON.parse(data);
        if (response.status === 'success') {
            obj.setState({
                response: 'success',
                objectData: response.Goods,
                subdata: response.Subgroup,
                sending: false,
            });
        } else if (response.status === 'error') {
            obj.setState({
                response: 'success',
                sending: false,
            });
        } else if (response.status === 'error-no-internet') {
            obj.setState({
                sending: false
            });
        }
    }

    // if click happen on goods close sheet and return scroll to normal
    onGoodClicked = () => {
        if(typeof this.props.clearSearch == 'function'){
            this.props.clearSearch();
        }
    }

    // make ui grid for goods
    makeSearchedGrid = () => {
        if(this.props.keyword.length < 2){
            return (
                    <div className="loading-container">
                        حداقل دو حرف تایپ کنید
                    </div>
                )
        }
        if(!this.state.sending) {
            let ans = [];
            if(this.state.subdata){
                let subgroups = this.state.subdata.map((value, index) => {
                    let allFilters = {
                        name: this.props.keyword,
                    }
                    const searchParams = new URLSearchParams(allFilters);
                    return (
                        <Link 
                            key={index} 
                            className='search-link' 
                            to={'/search/' + value.G_SUBGR_EN_NAME + '?'+ searchParams.toString()} 
                            onClick={this.onGoodClicked} 
                        >
                            <div className="image">
                                <svg >
                                    <path d="M22.0413 20.156L27.752 25.8653L25.8653 27.752L20.156 22.0413C18.0316 23.7443 15.3893 24.6705 12.6666 24.6667C6.04263 24.6667 0.666626 19.2907 0.666626 12.6667C0.666626 6.04266 6.04263 0.666656 12.6666 0.666656C19.2906 0.666656 24.6666 6.04266 24.6666 12.6667C24.6705 15.3893 23.7443 18.0316 22.0413 20.156ZM19.3666 19.1667C21.0588 17.4265 22.0038 15.0939 22 12.6667C22 7.50932 17.8226 3.33332 12.6666 3.33332C7.50929 3.33332 3.33329 7.50932 3.33329 12.6667C3.33329 17.8227 7.50929 22 12.6666 22C15.0939 22.0038 17.4265 21.0588 19.1666 19.3667L19.3666 19.1667Z" fill="#979797"/>
                                </svg>
                            </div>
                            <div className="detail">
                                <div className="nameG">
                                    <span className='name'>{this.props.keyword}</span>
                                    <span className='subtitle'>در دسته بندی <span className='imp'>{value.G_SUBGR_NAME}</span> </span>
                                    {/* <span className='shop'>تعداد فروشنده: {value.shop_count}</span>
                                    <Stars star={value.Ave}/> */}
                                </div>
                                {/* <Price min={value.Min} max={value.Max}/> */}
                            </div>
                        </Link>
                    )
                })
                ans.push(
                    <div className="sub-grid">
                        {subgroups}
                        <div className='line'></div>
                        <div className='top-find'>
                            <span className='good-list-tit'>محصولات مربوط</span>
                            <Link to={'/search' + '?name=' + this.props.keyword}onClick={this.onGoodClicked} className='more-good'>مشاهده بیشتر</Link>
                        </div>
                    </div>
                )
            }
           
            let lenght = (window.innerWidth > 850 ? 24 : 40)
            if(this.state.objectData){
                let goodlist = this.state.objectData.slice(0,5)
                let goods = goodlist.map((value, index) => {
                    return (
                        <Link 
                            key={index} 
                            className='good' 
                            to={{pathname: encodeURI('/good/' + value.Data.G_CODE+'/'+ value.Data.G_URL+'/')}} 
                            onClick={this.onGoodClicked} 
                            style={{width: `calc(${100 / 4}% - ${(8*(3))/4}px)`}}
                        >
                            <div className="image">
                                <img src={value.Data.G_IMAGE} alt={value.Data.G_NAME}/>
                            </div>
                            <div className="detail">
                                <div className="nameG">
                                    <span className='name'>{value.Data.G_NAME}</span>
                                    {/* <span className='brand'>برند:  {value.Data.G_BR_NAME} </span>
                                    <span className='shop'>تعداد فروشنده: {value.shop_count}</span>
                                    <Stars star={value.Ave}/> */}
                                </div>
                                {/* <Price min={value.Min} max={value.Max}/> */}
                            </div>
                        </Link>
                    )
                })
                ans.push(
                    <div className="good-grid" key='0'>
                        <div className='scrollable' style={{width: (4 * lenght) +"%"}}>
                            {goods}
                        </div>
                    </div>
                )
            } else {
                ans.push(
                    <div className="loading-container" key='0'>
                        محصولی یافت نشد
                    </div>
                )
            }
            return ans;
        } else {
            return (
                <div className="loading-container">
                   <Loading/>
                </div>
            )
        }
    }
    
    // main structure for rendering search ui
    render() {
        return (
            <Styles>
                {this.makeSearchedGrid()}
            </Styles>
        )
    }
}

export default SearchDrawerRes;
